import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { UserContext } from "../../providers/user-provider";
import moment from 'moment';
import { timestampToDateString } from '../../firebase';
import { FaCheck, FaSave, FaEye } from 'react-icons/fa';

const AddFeatureHeader = ({activeTab, featureData, lastSaveTime, onFeatureTabClick, onReviewsTabClick, onSave }) => {
	const user = useContext(UserContext);
	const userRole = user.role;
	const isFeatureDataLocked = featureData.status === 'approved' && user.role !== 'owner';
	const isFeatureDataComplete = featureData.name && featureData.type && (featureData.category || !featureData.type.hasSubCategories);

	function renderLastSaved () {
		let lastSaved;
		if (lastSaveTime) {
			lastSaved = `Today at ${moment().format('LT')}`;
		} else {
			lastSaved = featureData.reviewDate && timestampToDateString(featureData.reviewDate);
		}
		return (
			<>
			{lastSaveTime || lastSaved ?
			<span className={lastSaveTime ? 'review-modified status-success' : 'review-modified'}>Last Saved: <b>{ lastSaved }</b></span> : null
			}
			</>
		);
	}

	function renderStatus () {
		let featureStatus = featureData.status;

		return (
			<div className="feature-editor-status">
				<span className="feature-status">Feature Status: <b className={featureStatus === 'approved' ? 'status-success' : null}>{featureStatus}</b></span>
				{renderLastSaved()}
			</div>
		);
	}

	return (
		<div className="label-with-actions col-layout add-feature-header">
			<div className="label">
				<h1>Feature Editor</h1>
			</div>
			<div className="actions feature-editor-actions">
				{renderStatus()}
				<div className="action-buttons">
					<button className="link" onClick={() => {onSave('draft')}} disabled={!isFeatureDataComplete || isFeatureDataLocked }><FaSave />Save Draft</button>
					<button className="primary" disabled={!isFeatureDataComplete || isFeatureDataLocked } onClick={() => {onSave('pending')}}><FaEye />Submit for Review</button>
					{userRole === 'owner' &&
					<button className="super" disabled={!isFeatureDataComplete || isFeatureDataLocked } onClick={() => {onSave('approved')}}><FaCheck className="approve-icon" />Approve</button>
					}
				</div>
			</div>
		</div>
	);
};

AddFeatureHeader.propTypes = {
	activeTab: PropTypes.string,
	featureData: PropTypes.object,
	lastSaveTime: PropTypes.string,
	onFeatureTabClick: PropTypes.func,
	onReviewsTabClick: PropTypes.func
}

export default AddFeatureHeader;
